import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/content/site";

export function usePageMeta(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title
      ? `${title} | ${SITE.name}`
      : `${SITE.name} | Learn the World by Wandering Through It`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + pathname);
  }, [title, description, pathname]);
}
